import { MediaState } from '../domain/media-file.types';
import { MediaEvent } from '../media.events';

export const filesInitReducer = (
  state: MediaState,
  event: MediaEvent
): MediaState => {
  switch (event.type) {
    case 'MEDIA/INITIAL_FILES_SET':
      return event.files;

    case 'MEDIA/FILES_ADDED':
      return [...state, ...event.files];

    case 'MEDIA/FILE_REMOVED':
      return state.filter((file) => file.id !== event.file.id);

    default:
      return state;
  }
};
